// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"615":"f74bcdf3aa7aeefa","1999":"bc6cd1e626417509"}[chunkId] + ".css";
};